import comp from "./UpdateOrgAcademicYears";
export default comp;
